import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CheckoutResponse } from '../models/checkout.model';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
  private readonly API_URL = environment.API_URL;

  constructor(private readonly http: HttpClient) {}

  /**
   * Realiza o checkout de um staff (POST)
   * @param payload - Dados do checkout
   */
  checkoutStaff(payload: {
    memberId: string;
    description: string;
  }): Observable<CheckoutResponse> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
    return this.http.post<CheckoutResponse>(
      `${this.API_URL}/bpv/staffs/checkout`,
      payload,
      { headers }
    );
  }

  /**
   * Realiza a deserção de um staff (POST)
   * @param payload - Dados da deserção
   */
  desertionStaff(payload: {
    memberId: string;
    description: string;
  }): Observable<CheckoutResponse> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
    return this.http.post<CheckoutResponse>(
      `${this.API_URL}/bpv/staffs/desertion`,
      payload,
      { headers }
    );
  }

  /**
   * Busca informações do staff pelo ID (para pré-visualização)
   * @param staffId - ID do staff
   * @returns Observable com os dados do staff
   */
  getStaffById(staffId: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    return this.http.get<any>(
      `${this.API_URL}/bpv/members/id/${staffId}`,
      { headers }
    );
  }
}
